module.exports = __webpack_public_path__ + "img/img_size_05.db0202f6.png";